<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="synchro">同步</el-button>
                    </el-form-item>    
                </div>
               
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="title" label="直播名称" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="live_broadcast" label="直播地址" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!-- 设置 -->
        <el-dialog title="直播设置" :visible.sync="dialoged" top="80px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" :model="forms" label-width="140px"  class="demo-ruleForm">
                    <el-form-item label="直播名称" prop="problem">
                        <el-input size="small" v-model="forms.zs_value"></el-input>
                    </el-form-item>
                    <el-form-item label="直播连接地址" prop="problem">
                        <el-input size="small" v-model="forms.problem"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submited('forms')" size="small">确 定</el-button>
                <el-button @click="dialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                resource_id:'p_5fdb0346e4b0231ba88d4839',
                resource_type:'4',
                dialog: false,
                titles: '',
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 10,
                count: 0,
                heights: null,

                // 
                eid: '',
                dialogs: false,
                zs_options: [],
                form: {
                    zs_value: '',
                    textareas: '',
                },
               
                dialoged: false,
                forms: {
                    problem: '',
                    zs_value:'',
                },
                listItem: [],
                arrxq:'',
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            // that.getxx()
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 170 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 170 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 10
                that.search()
            },
            //同步
            synchro(){
                let that = this
                axios
                    .post("/admin/KkysXiaoet/UpdateColumnList",{
                        goods_id: that.resource_id,
                        goods_type:that.resource_type,
                    },{
                        token:true
                    })
                    .then(response =>{
                        that.tableData = response.data.data.data
                        that.search()
                    })
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/KkysXiaoet/getLocalColumnList", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.data
                        that.count = response.data.data.totalCount
                      
                        
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            // 新增
            add() {
                let that = this
                that.dialoged = true
                that.eid = '0'
                that.forms.problem = ''
            },
            // 设置
            submited(formName) {
                let that = this
                axios
                    .post("/admin/KkysXiaoet/updateLocalColumn", {
                        id:that.eid,
                        live_broadcast: that.forms.problem,
                        
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.dialoged = false
                         that.search() 
                              
                    })
                    .catch(error => {})
            },
            handleEdit(index, row) {
                let that = this
                that.dialoged = true
                that.eid = row.id
                 that.forms.zs_value = row.title
                that.forms.problem = row.live_broadcast
               
            },

        },

    };
</script>


<style scoped>
    .imgs {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
    }
    .lefts{
        max-height: 500px;
        overflow: auto;
    }
    .delt{
        color: red;
        font-size: 20px;
    }
    .blues{
        color: #409eff;
    }
    .concon{
      background: #f5f5f5;
      padding: 10px;
      border-radius: 10px;
    }
</style>